import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LumpSumPaymentInstruction } from '../../../../../models/transactions/lump-sum-payment-instruction';

@Component({
  selector: 'app-vb-view-past-lump-sum-payments-modal',
  templateUrl: './vb-view-past-lump-sum-payments-modal.component.html',
  styleUrls: ['./vb-view-past-lump-sum-payments-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbViewPastLumpSumPaymentsModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  public historicalLumpSumPayments: LumpSumPaymentInstruction[] = [];

  public readonly pageSize = 6;

  private _skip = new BehaviorSubject<number>(0);
  public skip$: Observable<number> = this._skip.asObservable();

  public pagedPayments$ = this.skip$.pipe(
    map(skip => {
      const sorted = [...this.historicalLumpSumPayments].sort((a, b) =>
        b.desiredPaymentDate.localeCompare(a.desiredPaymentDate)
      );
      return sorted.slice(skip, skip + this.pageSize);
    })
  );

  public onSkipChanged(skip: number): void {
    this._skip.next(skip);
  }

  public close(): void {
    this.ngbActiveModal.close();
  }
}
